import { render, staticRenderFns } from "./JoystickControl.vue?vue&type=template&id=2b3b6e33&scoped=true"
import script from "./JoystickControl.vue?vue&type=script&lang=js"
export * from "./JoystickControl.vue?vue&type=script&lang=js"
import style0 from "./JoystickControl.vue?vue&type=style&index=0&id=2b3b6e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b6e33",
  null
  
)

export default component.exports